import * as React from 'react'

import { useSearchParams } from 'react-router'

export function useJobSearchParams() {
  // urlSearchParams is a URLSearchParams object
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/searchParams
  const [urlSearchParams, setUrlSearchParams] = useSearchParams(
    window.location.search,
  )

  urlSearchParams.sort()

  const [paramString, setParamString] = React.useState(
    urlSearchParams.toString(),
  )

  const lockParamString = React.useCallback(
    (nextSearchParams = urlSearchParams) => {
      const params = new URLSearchParams(nextSearchParams)

      // Set paramString to be used for new query
      setParamString(params.toString())
      // Set the params to not yet add to this history stack
      // until we build a custom history stack
      setUrlSearchParams(params, { replace: true })
    },
    [setUrlSearchParams, urlSearchParams],
  )

  return {
    urlSearchParams,
    setUrlSearchParams,
    paramString,
    lockParamString,
  }
}
